import React, { useState } from "react";
import { CLICK, component, demoFile, feature, story } from "system/demo";
import { CatToggle, CatState, TypeFilter } from "feature/comments/demo-filter";

demoFile('feature/comments/demo-filter');

feature('Demo Filter', {
    structureKey: 'simplecomments',
    features: {demofilter: true}
});

function CatToggleDemo() {
    const [comment, setComment] = useState({isCat: false});
    return <CatToggle comment={comment} setComment={setComment} />;
}

component('CatToggle', CatToggleDemo, {}, [
    story('Toggle', [CLICK('!Is Cat')])
]);

component('CatState', CatState, {args: {comment: {isCat: true}}});
component('TypeFilter', TypeFilter, {}, [
    story('Enable', [CLICK('!Only Cats')])
]);

